export default {
  // 信用证删除
  DEL_CREDITLETTER: '/financial/creditLetter/delCreditLetter',
  // 信用证导出
  EXPORT_CREDITLETTER: '/financial/creditLetter/exportCreditLetter',
  // 信用证收证导出
  EXPORT_CREDITLETTER_RECEIPT: '/financial/creditLetter/exportCreditLetterReceipt',
  //信用证状态操作
  OPERA_CREDITLETTER: '/financial/creditLetter/operaCreditLetter',
  //信用证详情
  QUERY_CREDITLETTER_BY_ID: '/financial/creditLetter/queryCreditLetterById',
  //信用证分页查询
  QUERY_CREDITLETTER_PAGE: '/financial/creditLetter/queryCreditLetterPage',
  //信用证新增/修改
  SAVE_CREDITLETTER: '/financial/creditLetter/saveCreditLetter',
  //信用证提交
  SUBMIT_CREDITLETTER: '/financial/creditLetter/submitCreditLetter',
  //信用证承兑明细分页查询
  QUERY_LC_PAGE: '/financial/creditLetterAcceptance/queryCreditLetterAccPageList',

  //生成付款单
  CREATE_PAYMENT: '/financial/fundPayment/createPaymentForCredit',
  //信用证承兑删除
  DEL_CREDITLETTER_ACC: '/financial/creditLetterAcceptance/delCreditLetterAcc',
  //信用证承兑提交审批
  OPERA_CREDITLETTER_ACC: '/financial/creditLetterAcceptance/operaCreditLetterAcc',
  //信用证承兑详情
  QUERY_CREDITLETTER_ACC_BY_ID: '/financial/creditLetterAcceptance/queryCreditLetterAccById',
  //信用证承兑分页查询
  QUERY_CREDITLETTER_ACC_PAGE: '/financial/creditLetterAcceptance/queryCreditLetterAccPage',
  //信用证承兑新增/修改
  SAVE_CREDITLETTER_ACC: '/financial/creditLetterAcceptance/saveCreditLetterAcc',
  // 银行列表
  GET_LIST_BANK: '/maindata/sysBankBranch/listSysBankByPage',
  /** 获取列表 */
  DICT_LIST: '/maindata/dictData/listDataDictByDataType',
  // 合同列表查询
  LIST_PRODUCT_API: '/sales/orderDetail/listOrderDetailByPage',
  // 信用证承兑查询付款单
  QUERY_PAYMENTLIST_BY_ACCEPTANCE: '/financial/fundPayment/queryPayListByCreditLetterAcceptance',
  // 信用证开证承兑撤销
  REVOKELC: '/financial/creditLetterAcceptance/creditLetterRevoke',
  // 信用证开证申请撤销
  REVOKE_CREDITLETTER: '/financial/creditLetter/revokeCreditLetter',
  //批量上传
  IMPORT: '/financial/creditLetter/importCreditLetter',
  //批量提交
  BATCH_SUBMIT: '/financial/creditLetter/batchSubmit',
  //批量过账
  BATCH_VOUCHER: '/financial/creditLetter/batchSyncVoucher',
  //批量过账
  BATCH_SIGN_VOUCHER: '/financial/creditLetter/batchSignSyncVoucher',
  // 信用证收证撤销
  REVOKE_RECIVE_CREDITLETTER: '/financial/creditLetter/revokeReceiveCreditLetter',
  // 信用证议付提交审批接口
  SUBMIT_NEGOTIATION: '/financial/creditLetterNegotiate/submitNegotiation',
  // 信用证议付撤销接口
  REVOKE_NEGOTIATION: '/financial/creditLetterNegotiate/revokeNegotiation',
  // 信用证押汇撤销接口
  REVOKE_DELAY_PAYMENT: '/financial/creditLetterDelayPayment/revokeDelay',
  // 信用证押汇提交审批接口
  SUBMIT_DELAY_PAYMENT: '/financial/creditLetterDelayPayment/submitDelay',
  // 信用证锁汇提交审批接口
  SUBMIT_DELAY_LOCK: '/financial/creditLetterDelayLock/submitLock',
  // 信用证锁汇撤销接口
  REVOKE_DELAY_LOCK: '/financial/creditLetterDelayLock/revokeLock',
  // 保存全部信息 承兑
  SVE_ALL: '/financial/creditLetter/saveInternationalCreditLetterInformation',
  // 信用证承兑查询付款单V2
  QUERY_INFORMATION: '/financial/fundPayment/queryPaidListByClCode',
};
